import { useState } from 'react';
import { useLocation } from 'react-router';

function LogoMark({ light = false }: { light?: boolean }) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <span className="inline-flex items-center gap-2.5">
        <span
          className={`flex h-7 w-7 items-center justify-center rounded-sm ${
            light ? 'bg-white' : 'bg-zeb-secondary'
          }`}>
          <span
            className={`text-meta font-bold tracking-tight ${
              light ? 'text-zeb-secondary' : 'text-white'
            }`}>
            zeb
          </span>
        </span>
        <span className={`text-sm ${light ? 'text-white' : 'text-zeb-gray-600'}`}>
          Customer Centricity Check
        </span>
      </span>
    );
  }

  return (
    <img
      src="/brand/zeb-logo.svg"
      alt="zeb"
      className={`h-[38px] w-auto ${light ? '[filter:brightness(0)_invert(1)]' : ''}`}
      onError={() => setErrored(true)}
    />
  );
}

export function Header({ onLogoClick }: { onLogoClick: () => void }) {
  // Auf der Landing-Page liegt der Header transparent über dem blauen Hero
  // (Logo weiß); er scrollt mit dem Hero weg. Auf allen anderen Seiten bleibt
  // er ein normaler Header im Fluss.
  const isLanding = useLocation().pathname === '/';

  return (
    <header className={isLanding ? 'absolute inset-x-0 top-0 z-20' : 'w-full'}>
      <div className="mx-auto flex max-w-6xl items-center justify-center px-5 lg:px-10 py-6">
        <button
          onClick={onLogoClick}
          aria-label="Zur Startseite"
          className="inline-flex transition-opacity hover:opacity-80">
          <LogoMark light={isLanding} />
        </button>
      </div>
    </header>
  );
}
